// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import BaiduMap from 'vue-baidu-map'
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
import axios from 'axios'
import VueSeamlessScroll from 'vue-seamless-scroll'

Vue.use(Element)
Vue.use(VueSeamlessScroll)
Vue.prototype.$axios = axios
Vue.config.productionTip = false

// 引入百度地图
Vue.use(BaiduMap, {
  ak: 'r9l4T6epno1WWf2tED7VgeCgG2uqWldw'
})
Vue.use(BmMarker)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js